import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getDocumentSeriesReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    // Only include document_type if it has a valid value
    if (searchQuery.document_type) {
        params.document_type = searchQuery.document_type;
    }

    // Include society_id if provided
    if (searchQuery.society_id) {
        params.society_id = searchQuery.society_id;
    }

    // Include invoice_type_id if provided
    if (searchQuery.invoice_type_id) {
        params.invoice_type_id = searchQuery.invoice_type_id;
    }

    return axiosInstance.get(apiEndpoints.GET_DOCUMENT_SERIES_API, { params });
}

export const getDocumentSeriesDetailsReq = (action) => {
    const documentSeriesId = action?.data?.id || ''
    const url = apiEndpoints.GET_DOCUMENT_SERIES_DETAILS_API.replace(':id', documentSeriesId)
    return axiosInstance.get(url);
}

export const createDocumentSeriesReq = (action) => {
    const payload = action?.data || {}
    return axiosInstance.post(apiEndpoints.CREATE_DOCUMENT_SERIES_API, payload);
}

export const updateDocumentSeriesReq = (action) => {
    const documentSeriesId = action?.data?.id || ''
    let payload = { ...action?.data } || {}
    delete payload.id;
    delete payload.onSuccess;
    const url = apiEndpoints.UPDATE_DOCUMENT_SERIES_API.replace(':id', documentSeriesId)
    return axiosInstance.put(url, payload);
}

export const deleteDocumentSeriesReq = (action) => {
    const documentSeriesId = action?.data?.id || ''
    const societyId = action?.data?.society_id
    const url = apiEndpoints.DELETE_DOCUMENT_SERIES_API.replace(':id', documentSeriesId)
    const params = societyId ? { society_id: societyId } : {}
    return axiosInstance.delete(url, { params });
}

export const previewDocumentSeriesReq = (action) => {
    const params = action?.data || {}
    return axiosInstance.get(apiEndpoints.PREVIEW_DOCUMENT_SERIES_API, { params });
}
